import { Activity } from "./activity";

export interface SolveActivity extends Activity {}
